import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { state } from "@angular/animations";
import { MessageService } from "primeng/api";
import { AdService } from "../ad.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-ad",
  templateUrl: "./ad.component.html",
  styleUrls: ["./ad.component.css"],
  providers: [MessageService]
})
export class AdComponent implements OnInit {
  rdForm: any;
  fileSelected: File;
  filesToUpload: any;
  token: any;
  changeListData = [];
  isDisabled = true;
  
  constructor(
    private messageService: MessageService,
    private adService: AdService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    this.oninitform();
  }

  oninitform() {
    this.rdForm = new FormGroup({
      adfor: new FormControl(null, Validators.required),
      // district: new FormControl(null, Validators.required),
      // line1: new FormControl(null, Validators.required),
      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),
      // title: new FormControl(null, Validators.required),
      // description: new FormControl(null, Validators.required),
      website: new FormControl(null),
      city: new FormControl(null, Validators.required),
      advClientId: new FormControl({ value: null, disabled: true }),
      // pincode: new FormControl(null, [
      //   Validators.required,
      //   Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      // ]),
      // state: new FormControl(null, Validators.required)
    });
  }
  onSelectadFor(value) {
    this.changeListData = [];
    this.adService.getChangeList(value, this.token).subscribe(res => {
      this.changeListData = res.data;
      this.isDisabled = this.changeListData.length <= 0;
      this.rdForm.controls["advClientId"].enable();
    });
  }

  onAddPhoto(event) {
    this.fileSelected = <File>event.target.files[0];
    //this.fd.append('profileimage',fileSelected,fileSelected.name)
  }
  onSubmit() {
    // const line1 = this.rdForm.value["line1"];
    // const district = this.rdForm.value["district"];
    const adfor = this.rdForm.value["adfor"];
    const city = this.rdForm.value["city"];
    // const pincode = this.rdForm.value["pincode"];
    // const state = this.rdForm.value["state"];
    const startDate = this.rdForm.value["startDate"];
    // const description = this.rdForm.value["description"];
    const website = this.rdForm.value["website"];
    // const title = this.rdForm.value["title"];
    const endDate = this.rdForm.value["endDate"]; //advClientId
    const advClientId = this.rdForm.value["advClientId"]
      ? this.rdForm.value["advClientId"]
      : null;
    if (this.fileSelected) {
      this.adService
        .saveAds(
          this.fileSelected,
          startDate,
          endDate,
          adfor,
          advClientId,
          // line1,
          // district,
          city,
          // state,
          // pincode,
          // title,
          website,
          // description,
          this.token
        )
        .subscribe(res => {
          console.log(res);
          this.oninitform();
        });
    }
  }
}
